app.mediator.registerModule(MODULE_NAME__CTA_COLLECTION, function (app) {

    var helpers = app.helpers.funcs;

    return {

        $rootElem: null,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {
            var scope = this;
            this.$rootElem = $('.mod-cta-collection');
            if (!this.$rootElem.length) return;

            // Equalise the div heights
            this.equaliseDivHeights();

            // And also run it in response to a screen resize.
            app.globalEventRegistry.addListener('resize', helpers.throttler(function () {
                scope.equaliseDivHeights();
            }, 200));

            // And also run it after a couple of seconds as a "last chance" call.
            // This will have no adverse effect if div heights have already been correctly adjusted.
            setTimeout(function () {
                scope.equaliseDivHeights();
            }, 2000);
        },

        equaliseDivHeights: function () {
            var itemsPerRowPerBreakpoint = {};
            itemsPerRowPerBreakpoint[app.helpers.screenBreakpoints.xs] = 1;
            itemsPerRowPerBreakpoint[app.helpers.screenBreakpoints.sm] = 2;
            itemsPerRowPerBreakpoint[app.helpers.screenBreakpoints.md] = 3;
            itemsPerRowPerBreakpoint[app.helpers.screenBreakpoints.lg] = 3;
            helpers.equaliseDivHeights(this.$rootElem.find('.cta-item-wrap'), itemsPerRowPerBreakpoint);
        }
    };
});